// page/auth/admin/modals/DutyEditModal.jsx
import React, { useEffect, useState } from "react";
import { api } from "../../../../util/api";
import { Stack, TextField } from "@mui/material";
import { notify } from "../../../../util/toast";
import { confirm as confirmDialog } from "../../../../util/confirmDialog";
import { runApiAction } from "../../../../util/apiFeedback";
import { API } from "../api/endpoints";
import FormField from "../../../../component/common/FormField";
import FormModal from "../../../../component/common/FormModal";
import ActionButton from "../../../../component/common/ActionButton";

export default function DutyEditModal({ open, onClose, initial, onSaved, onDeleted }) {
    const isEdit = !!initial;

    const [name, setName] = useState("");

    useEffect(() => {
        if (!open) return;
        setName(initial?.dutyName || "");
    }, [open, initial]);

    const validate = () => {
        if (!name.trim()) return "직책명은 필수입니다.";
        return null;
    };

    const save = () => {
        const msg = validate();
        if (msg) return notify(msg, "warning");

        return runApiAction({
            request: () => isEdit
                ? api.put(API.duties.update(initial.dutyId), { dutyName: name.trim() })
                : api.post(API.duties.create, { dutyName: name.trim() }),
            successMsg: isEdit ? "직책이 수정되었습니다." : "직책이 생성되었습니다.",
            onSuccess: () => onSaved?.(),
        });
    };

    const handleDelete = async () => {
        if (!isEdit) return;
        if (!(await confirmDialog({ message: `직책(${initial.dutyName})을 삭제할까요?` }))) return;
        return runApiAction({
            request: () => api.delete(API.duties.delete(initial.dutyId)),
            successMsg: "직책이 삭제되었습니다.",
            onSuccess: () => (onDeleted ?? onClose)?.(),
        });
    };

    return (
        <FormModal
            open={open}
            onClose={onClose}
            title={isEdit ? "직책 수정" : "직책 생성"}
            subtitle={isEdit ? `ID: ${initial.dutyId}` : undefined}
            maxWidth="sm"
            onSave={save}
            saveLabel={isEdit ? "수정" : "생성"}
            footerExtras={isEdit && (
                <ActionButton variant="delete" onClick={handleDelete} sx={{ fontSize: 12 }} />
            )}
        >
            <Stack spacing={1.25}>
                <FormField label="직책명" required>
                    <TextField
                        autoFocus
                        fullWidth
                        size="small"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="직책명을 입력하세요 (예: 팀장·기획자·디자이너·PD)"
                    />
                </FormField>
            </Stack>
        </FormModal>
    );
}
